
import { Tabs } from "antd";
const { TabPane } = Tabs

type Props = {
    AllTabs: Array<any>,
    onChange?: (values: string) => void
}

function TabsLayout({ AllTabs, onChange }: Props) {
    return (
        <div>
            <Tabs defaultActiveKey="1" onChange={onChange}>
                {
                    AllTabs.map((tab: any, index: number) => {
                        return <TabPane className={"nopadding-tab"} tab={tab.title} key={index + 1}>
                            {tab.component}
                        </TabPane>
                    })
                }
            </Tabs>
        </div>
    );
}

export default TabsLayout;
